import React, { useState } from "react";
import {
    Routes,
    Route,
    BrowserRouter,
    useLocation,
    useNavigate
} from "react-router-dom";
import {
    Home as HomeIcon,
    ReceiptLong,
    Person
} from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { ToastContainer } from "react-toastify";

import HubHome from "./HubHome";
import Conta from "../FoodDeliveryPage/Conta";
import LivePage from "./LivePage";
import StoryPage from "./StoryPage";
import PerfilPage from "./PerfilPage";

// Componente para controlar a navegação e visibilidade da barra inferior
function BottomNavWrapper() {
    const location = useLocation();
    const navigate = useNavigate();
    const [navValue, setNavValue] = useState(0);

    // Definimos em quais rotas a barra DEVE aparecer
    // Exemplo: Apenas na home, lista de pedidos e perfil
    const rotasComBarra = ["/"];

    // Se o pathname atual for /live/123, /story, etc., não renderiza a barra
    const ocultarBarra = !rotasComBarra.includes(location.pathname);

    if (ocultarBarra) {
        return null;
    }

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                maxWidth: '480px',
                mx: 'auto',
                borderTop: '1px solid #eee',
                zIndex: 1000
            }}
            elevation={3}
        >
            <BottomNavigation
                value={navValue}
                onChange={(event, newValue) => {
                    setNavValue(newValue);
                    if (newValue === 0) navigate('/');
                    if (newValue === 1) navigate('/pedidos');
                    if (newValue === 2) navigate('/perfil');
                }}
                sx={{ '& .Mui-selected': { color: '#562dab !important' } }}
            >
                <BottomNavigationAction label="Início" icon={<HomeIcon />} />
                <BottomNavigationAction label="Pedidos" icon={<ReceiptLong />} />
                <BottomNavigationAction label="Perfil" icon={<Person />} />
            </BottomNavigation>
        </Paper>
    );
}

function HubPedidos() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HubHome />} />
                <Route path="/story" element={<StoryPage />} />
                <Route path="/live/:id" element={<LivePage />} />
                <Route path="/perfil" element={<PerfilPage />} />

                <Route path="/auth/login/:store" element={<Conta />} />
            </Routes>

            <ToastContainer />
            <BottomNavWrapper />
        </BrowserRouter>
    );
}

export default HubPedidos;